
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="row">
    <div class="col-12">
      <app-card cardTitle="Empresas Cadastradas" blockClass="table-border-style" [options]="false">
        <div class="row">
            <div class="col-md-6 col-sm-6">
              <label for="exampleInputEmail1">Filtro</label>
              <input type="text" class="form-control" [(ngModel)]="query"
                placeholder="Digite seu filtro, sera feito uma busca em todas as colunas" >
            </div>

                <div class="col-md-6 col-sm-6" style="top: 28px;">                  
                  <button type="button" class="btn btn-primary float-right " (click)="AdicionarNovaEmpresa()">
                    <i class="feather icon-plus mr-2 f-18"></i>
                    Cadastrar Nova Empresa
                  </button>
                </div>
           
            <!--<div class="col-md-2 col-sm-12">
              <br>
              <label for="exampleInputEmail1">&nbsp;</label>
              <button type="button"  class="btn btn-icon btn-warning"><i
                class="feather icon-refresh-cw"></i> Atualizar</button>
            </div>-->
          </div>
          <br>
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Nome</th>
                <th>CNPJ</th>
            
                <th></th>
                <th></th>
               
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of arrayTriagem  | fullTextSearch:query">
                <td>{{item.Nome }}</td>
                <td>{{item.Cnpj}}</td>
                <!--<td>{{item.datA_INICIO | date: "dd/MM/yyyy"}}</td>
                <td>{{item.datA_FIM | date: "dd/MM/yyyy"}}</td>-->
                <td>
                  <span *ngIf="item.revisado" class="badge badge-success">APROVADO</span>
                  <span *ngIf="!item.revisado" class="badge badge-warning">EM CURSO</span>
                </td>
                <td>
                  <!--<button *ngIf="item.revisado" type="button" class="btn btn-icon btn-success " ngbTooltip="Copie seu link" (click)="mostrarLink(item)">
                    <i class="feather icon-link"></i>
                  </button> 
                  <button *ngIf="!item.revisado" type="button" class="btn btn-icon btn-warning " ngbTooltip="Triagem não revisada" (click)="mostrarLink(item)">
                    <i class="feather icon-link"></i>
                  </button>   &nbsp;&nbsp;&nbsp; -->
                  <button type="button" class="btn btn-icon btn-info " ngbTooltip="Editar" >
                    <i class="feather icon-edit"></i>
                  </button>  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-danger " >
                    <i class="fa fa-trash"></i>
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-icon btn-warning " ngbTooltip="Ver Programa" (click)="VerProgarmas()">
                    <i class="fa fa-eye"></i>
                  </button>
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
      </app-card>
    </div>
  </div>
  